import React from 'react';
import clsx from 'clsx';
import Lottie from 'lottie-react';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import RichText from '@common/RichText';

import btsSummitBannerLogo from '@images/bts-summit-banner-logo.json';

import * as styles from './summit-sign-up-banner.module.scss';

const SummitSignUpBanner = ({ data }) => {
  const {
    title,
    showTitle,
    showBorder,
    text,
    textAlignment,
    textFontSize,
    textFontFamily,
    textColWidth,
    colAlignment,
    listClass,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    imageNegativeMargin,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgPadding,
    bgFullwidth
  } = data;
  return (
    <Section spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour}`]: bgColour,
        [bgPadding]: bgPadding,
        ['container']: !bgFullwidth
      })}>
      <Container>
        <Row>
          <div className='col position-relative'>
            <Lottie animationData={btsSummitBannerLogo} loop={true} className={styles.btsSummitLogo}/>
          </div>
          <div className={clsx('col-12 col-lg-9', {
            'text-center': textAlignment === 'Center',
            'text-end': textAlignment === 'Right',
            'text-start': textAlignment === 'Left',
          })}>
            {(showTitle && title) &&
              <div className='d-flex justify-content-center'>
                <p className='text-uppercase fs-14 fw-medium bg-teal rounded mb-1 px-1'>{title}</p>
              </div>  
            }
            {text && <RichText json={text} a='text-black' p='mb-1'/>}
          </div>
        </Row>
      </Container>
    </Section>
  )
}

export default SummitSignUpBanner
